<template>
  <div class="img_box" @click="goAuthV1">
    <img class="login_other_img" src="../../../assets/img/h5_login_icon01.png" />
  </div>
</template>
<script>
var _self;
import { myMixin } from "@/tools/mixins.js";
import { getDefaultApiCommon, isSafari } from "@/tools/common.js";
export default {
  name: "LoginTwitter",
  mixins: [myMixin],
  data() {
    return {
    };
  },
 async  mounted() {
    _self = this;
    let twitterAuthorizationCode = this.getParamsHash('code');
    let twitterCodeVerifier = this.getParamsHash('codeChallengeVerifier');
    let tokenSecret = this.getParamsHash('state');
    let type = this.getParamsHash('type');
    let uid = this.getParamsHash('uid');
    let at = this.getParamsHash('at');
    let otse = this.getParamsHash('otse');

    if (type === 'twitter' && (twitterAuthorizationCode && twitterCodeVerifier && tokenSecret)) {
    const res = await   this.confirmLogin(8, {
        twitterAuthorizationCode,
        twitterCodeVerifier,
        tokenSecret,
      });

      if(res && res.loginAgain) {
        this.goAuthV1();
      }
    }

    if(type==='twitter'&&uid&&at&&otse){
      this.confirmLogin(8,{
        "uid":uid,
        "accessToken":at,
        "tokenSecret":otse
      });
    }


    // this.$store.commit("confirmLogin", {
    //   "type": 8,
    //   "twitterAuthorizationCode": twitterAuthorizationCode,
    //   "twitterCodeVerifier": twitterCodeVerifier,
    //   "tokenSecret": tokenSecret
    // });
  },
  methods: {
    //跳转中转页授权
    goAuth() {
    //  this.gosdkAuth(1, `twitterAuth.html?platform=bcnewpay&Api_common=${getDefaultApiCommon()}&t=${Date.now()}`)
      if(isSafari()){
        this.goAuthV1();
      }
      else  {
        let platform = 'bcnewpay'+this.getSuffix()
        this.gosdkAuth(1, `twitterAuth.html?platform=${platform}&Api_common=${getDefaultApiCommon()}&t=${Date.now()}`);
      }

    },
    goAuthV1(){
      let platform = 'bcnewpay'+this.getSuffix()
      this.gosdkAuth(1, `twitterAuth.html?platform=${platform}&t=${Date.now()}`);
    }


  },
};
</script>
<style scoped>
.img_box {
  margin: 0 0.15rem;
}

.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkTwitter.vue